import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import { BackdropCircular, DesignedInfoDialog } from 'components';
import { createQuoteProPackageApi, getQuoteProPackagesApi } from 'api';
import { useStyles } from '../styles';


const CreatePackageButton = ({
  isDisabled,
  packageItems,
  totalPrice,
  btnFullWidth = false,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [packageDialogData, setPackageDialogData] = useState({
    isOpenModal: false,
    name: '',
    error: '',
    touched: false
  });

  const {
    savePackageLoading,
    quoteProPackagesData
  } = useSelector((state: IReduxState) => state.quote);

  useEffect(() => {
    if (!quoteProPackagesData?.quotePackages?.length || (quoteProPackagesData?.quotePackages?.length !== quoteProPackagesData?.totalCount)) {
      getQuoteProPackagesApi({
        dispatch,
        name: '',
        sortField: 'createdAt',
        sortDir: 'desc',
        limit: '100',
        page: '1'
      });
    }
  }, []);

  const handleSavePackage = async () => {
    setPackageDialogData((packageData) => ({...packageData, isOpenModal: false}));

    const packageData = {
      name: packageDialogData.name,
      price: totalPrice,
      selectedProducts: packageItems
    };

    await createQuoteProPackageApi({dispatch, packageData});
  };

  const handlePackageNameChange = (value) => {
    setPackageDialogData((packageData) => ({ ...packageData, name: value, touched: true  }));
    const isDuplicateName = quoteProPackagesData?.quotePackages.some((item) => item.name === value);

    if (isDuplicateName) {
      const error = 'Package name is already exist';
      setPackageDialogData((packageData) => ({ ...packageData, error }));
    } else if (!isDuplicateName && packageDialogData.error.length) {
      setPackageDialogData((packageData) => ({ ...packageData, error: '' }));
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        disabled={isDisabled}
        fullWidth={btnFullWidth}
        onClick={() => setPackageDialogData({isOpenModal: true, name: '', error: '', touched: false})}
      >
        Create New Package
      </Button>
      <DesignedInfoDialog
        open={packageDialogData.isOpenModal}
        setOpen={() => setPackageDialogData(
          (packageData) => ({...packageData, isOpenModal: false})
        )}
      >
        <div className={classes.modalTitle}>
          Package Name
        </div>
        <div>
          <TextField
            fullWidth
            variant="outlined"
            name="name"
            placeholder="Type..."
            className="max-w-280 mb-4"
            onChange={({target: {value}}) => handlePackageNameChange(value)}
            error={packageDialogData.touched && Boolean(packageDialogData.error)}
            helperText={packageDialogData.touched && packageDialogData.error}
          />
        </div>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setPackageDialogData(
            (packageData) => ({...packageData, isOpenModal: false, error: '', touched: false})
          )}
          className="mx-2 my-6 w-120 uppercase"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSavePackage}
          disabled={!packageDialogData.name.length || !!packageDialogData.error.length}
          className="mx-2 my-6 w-120 uppercase"
        >
          Save
        </Button>
      </DesignedInfoDialog>
      <BackdropCircular loading={savePackageLoading} />
    </>
  );
};

export default CreatePackageButton;
